const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'brandId_standard',
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
